import "./style.scss";
import { auth } from "../global";
import { signInWithEmailAndPassword } from "firebase/auth";
import { FirebaseError } from "firebase/app";

/* START HTML */
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const appDiv = document.querySelector<HTMLDivElement>(".entry")!;
appDiv.innerHTML = `
<form id="firebase-login-form">
  <div>
    <label for="email">E-mail</label>
    <br>
    <input name="email" type="email">
  </div>
  <div>
    <label for="password">Password</label>
    <br>
    <input name="password" type="password">
  </div>
  <p>
    <a href="passwort-vergessen">Passwort vergessen?</a>
    <br>
    <button type="button" id="firebase-form-submit" class="firebase-btn">Login</button>
  </p>  
  <p id="firebase-login-error" ></p>
</form>
`;

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const submitButton = document.querySelector<HTMLButtonElement>("#firebase-form-submit")!;
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const loginForm = document.querySelector<HTMLFormElement>("#firebase-login-form")!;
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const errorOut = document.querySelector<HTMLParagraphElement>("#firebase-login-error")!;
/* END HTML */

console.log();
submitButton.onclick = () => {
  const data = new FormData(loginForm);
  const email = data.get("email")?.toString();
  const password = data.get("password")?.toString();

  if (email && password) {
    signInWithEmailAndPassword(auth, email, password)
      /* .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        // ...
      }) */
      .catch((e: FirebaseError) => {
        console.log(e.customData);
        console.log(e.code);

        if (e.code === "auth/wrong-password") {
          errorOut.innerText = "Email oder Passwort ist Falsch!";
        }
        if (e.code === "auth/too-many-requests") {
          errorOut.innerText = "Zu viele Fehlversuche";
        }
      });
  } else {
    errorOut.innerText = "Email oder Passwort fehlt!";
  }
};

//check auth
auth.onAuthStateChanged(function (user) {
  if (user) {
    // User is signed in.
    window.location.href = "/intern";
  } else {
    // No user is signed in.
  }
});
